module.exports = __webpack_public_path__ + "static/img/mifi-back.a2844188.png";